import React, { useMemo, useState } from 'react';
import Filters from '../../../components/Filter';
import FilterInput from '../../../components/Filter/components/FilterInput';
import { translate } from '../../../services/translate';
import { NavigationProp, RouteProp, useNavigation } from '@react-navigation/native';
import { CitizenParamList } from '../../../typings/Params';
import { CitizenStatus } from '../../../services/central-api/citizen';
import { useStyles } from 'react-native-unistyles';
import FilterDropdown from '../../../components/Filter/components/FilterDropdown';

interface Props {
    filters: CitizenParamList['CitizenManagement'];
    setFilters: React.Dispatch<React.SetStateAction<CitizenParamList['CitizenManagement']>>;
    textFilter: string;
    setTextFilter: (value: string) => void;
}

function Filter({ filters, setFilters, textFilter, setTextFilter }: Props) {
    const { theme } = useStyles();
    const navigation = useNavigation<NavigationProp<RouteProp<CitizenParamList, 'CitizenManagement'>>>();

    const [status, setStatus] = useState<CitizenStatus | null>(filters.status ?? null);

    const handleCleanFilter = () => {
        setTextFilter('');
        setStatus(null);
    };

    const handleFilter = () => {
        navigation.setParams({
            ...filters,
            page: 1,
            textFilter,
            status: status ? status : undefined,
        });

        setFilters({
            ...filters,
            page: 0,
            textFilter,
            status: status ? status : undefined,
        });
    };

    const citizenStatusItems = useMemo(() => {
        return Object.values(CitizenStatus)
            .map((val) => ({
                label: val === 'disabled' ? translate('disabled_alt') : translate(val),
                value: val,
                color: theme.colors.primary['500'],
                textColor: theme.colors.white['500']
            }));
    }, []);

    return (
        <Filters onCleanFilters={handleCleanFilter} onFilters={handleFilter}>
            <FilterInput
                label={translate('typeToSearch')}
                value={textFilter}
                placeholder={translate('typeToSearch')}
                onChange={setTextFilter}
            />

            <FilterDropdown
                label={translate('status')}
                items={citizenStatusItems}
                zIndex={3}
                value={status}
                setValue={setStatus}
            />
        </Filters>
    );
}


export default Filter;
